import React from 'react';
import { Box, Input as ThemeUIInput, InputProps } from '@apia/theme';

export type TInput = InputProps & {
  /**
   * Convierte el input en un input que solamente tiene borde inferior, y al
   * hacer foco ese borde crece desde el centro con color primario
   */
  asMaterial?: boolean;
};

const Input = React.forwardRef<HTMLInputElement, TInput>(
  ({ asMaterial, ...props }, ref) => {
    return (
      <Box
        className="input__wrapper"
        variant={asMaterial ? 'forms.input.material' : undefined}
      >
        <ThemeUIInput {...props} ref={ref} />
        <Box className="input__underline" />
      </Box>
    );
  },
);

export default Input;
